import angular from 'angular';

import AuthServiceProvider from './auth.service';
import LoginComponent from './login-view';
import AccessDirective from './access.directive';

const module = angular
    .module('app.auth', [])
    .service('AuthService', AuthServiceProvider)
    .component(LoginComponent.selector, LoginComponent)
    .directive('sbAccess', () => new AccessDirective())
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/auth/index.js